/* tslint:disable */
/* eslint-disable */
/**
 * BlackFriday API
 * The API Documentation for BlackFriday
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import type { GenericIdDTO } from "./GenericIdDTO";
import { GenericIdDTOFromJSON, GenericIdDTOFromJSONTyped, GenericIdDTOToJSON } from "./GenericIdDTO";

/**
 *
 * @export
 * @interface DeleteManyExternalDealFiltersDTO
 */
export interface DeleteManyExternalDealFiltersDTO {
  /**
   *
   * @type {Array<GenericIdDTO>}
   * @memberof DeleteManyExternalDealFiltersDTO
   */
  filterIds: Array<GenericIdDTO>;
}

/**
 * Check if a given object implements the DeleteManyExternalDealFiltersDTO interface.
 */
export function instanceOfDeleteManyExternalDealFiltersDTO(value: object): boolean {
  let isInstance = true;
  isInstance = isInstance && "filterIds" in value;

  return isInstance;
}

export function DeleteManyExternalDealFiltersDTOFromJSON(json: any): DeleteManyExternalDealFiltersDTO {
  return DeleteManyExternalDealFiltersDTOFromJSONTyped(json, false);
}

export function DeleteManyExternalDealFiltersDTOFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): DeleteManyExternalDealFiltersDTO {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    filterIds: (json["filterIds"] as Array<any>).map(GenericIdDTOFromJSON)
  };
}

export function DeleteManyExternalDealFiltersDTOToJSON(value?: DeleteManyExternalDealFiltersDTO | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    filterIds: (value.filterIds as Array<any>).map(GenericIdDTOToJSON)
  };
}
